module.exports = __webpack_public_path__ + "static/media/Millijoin_Logo_Pink.fa8496d6.svg";